import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpHandler, HttpRequest, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

/**
 * Interceptor that parses JSON out of Blob error responses of type 'application/json'.
 * See https://github.com/angular/angular/issues/19888
 */
@Injectable()
export class BlobErrorHttpInterceptor implements HttpInterceptor {
   public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
      return next.handle(req).pipe(
         catchError((err) => {
            if (
               err instanceof HttpErrorResponse &&
               err.error instanceof Blob &&
               err.error.type === 'application/json'
            ) {
               return new Promise<any>((_resolve, reject) => {
                  const reader = new FileReader();
                  reader.onload = (e: Event) => {
                     // Read the Blob as JSON and build a new HttpErrorResponse
                     // that has the parsed error and all the original error's
                     // headers, status, etc.
                     try {
                        const parsedError = JSON.parse((e.target as any).result);
                        reject(
                           new HttpErrorResponse({
                              error: parsedError,
                              headers: err.headers,
                              status: err.status,
                              statusText: err.statusText,
                              url: err.url ?? undefined,
                           })
                        );
                     } catch (e) {
                        reject(err);
                     }
                  };
                  reader.onerror = (e) => {
                     // If the file reader fails for any reason, return the original error.
                     // This interceptor is a no-op in this case.
                     reject(err);
                  };
                  reader.readAsText(err.error);
               });
            }
            return throwError(err);
         })
      );
   }
}
